import { ConvertToCloudFrontUrl } from '../utils/ConvertToCloudFrontUrl.js';

export const UploadFileToS3 = async (file, setFile, formState, setFormState, setIsLoading, setProcess, userId) => {
    setIsLoading(true);
    
    if (!file) return;

    try {
        const query = new URLSearchParams({
            fileName: file.name,
            fileType: file.type,
            userId: String(userId || ''),
        });

        // Gửi request để lấy presigned URL
        const response = await fetch(`${process.env.REACT_APP_URL_WEB_SERVER_ROUTER_UPLOADS3}/?${query.toString()}`, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error('Failed to get presigned URL');
        }

        const data = await response.json();

        // Kiểm tra nếu data có chứa `url`
        if (!data.url) {
            throw new Error('Response does not contain the URL');
        }
        
        
        const { url } = data;

        // Tải file lên S3 bằng presigned URL
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Content-Type', file.type);

        xhr.upload.onprogress = function (event) {
            const progress = Math.round((event.loaded / event.total) * 100);
            setProcess(progress);
        };
        const urlFix = ConvertToCloudFrontUrl(url.split('?')[0])
        
        xhr.onload = () => {
            if (xhr.status === 200) {
                
                setFormState({
                    ...formState,
                    urlDocument: urlFix, // Lấy URL của file sau khi tải lên
                    // urlDocument: url.split('?')[0], // Lấy URL của file sau khi tải lên
                });
                
            } else {
                console.error('Upload error', xhr.responseText);
                alert('Tải lên không thành công')
            }
            setIsLoading(false);
            setProcess(0)
            setFile(null);
            
        };

        xhr.onerror = () => {
            console.error('Error during file upload');
            setIsLoading(false);
            setProcess(0);
        };

        xhr.send(file);
    } catch (error) {
        console.error('Error uploading file to S3:', error);
        setIsLoading(false);
        setProcess(0);
    } 
    // finally {
    //     setIsLoading(false);
    // }
};
